import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { DeviceWidth } from 'ecs-react-components/dist/index.es';
import TestResults from '../../containers/TestResults/TestResults';
import TestResultsCompact from '../../containers/TestResults/TestResultsCompact';
import { loadTestResults } from '../../redux/modules/test-results/test-results-middleware';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

const TEST_RESULTS_VIEW_AUDIT_TYPE = 'testresultsviewauditevent';

class TestResultsPage extends React.Component {
  componentDidMount() {
    this.props.dispatch(callWithLoadingIndicator(
      'TestResults',
      () => this.props.dispatch(loadTestResults(this.props.patientId)))
    );
    this.props.dispatch(auditRequest(TEST_RESULTS_VIEW_AUDIT_TYPE, this.props.patientId));
  }

  getTestResultsComponentBySize() {
    const compactView = this.props.windowSize === DeviceWidth.Small.name
      || this.props.windowSize === DeviceWidth.XSmall.name;

    if (compactView) {
      return <TestResultsCompact />;
    }
    return <TestResults />;
  }

  render() {
    return (
      this.getTestResultsComponentBySize()
    );
  }
}

TestResultsPage.propTypes = {
  windowSize: PropTypes.string,
  patientId: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.window.size,
  patientId: state.profile.patient.patientId,
});

export default connect(mapStateToProps)(TestResultsPage);